<template lang="pug">
header.logo-header
  a(v-if='homeUrl' :href='homeUrl')
    img.logo(:src="$store.getters.currentTenantSquareLogoPath" :title="$app.info" :alt="$app.info")
  img.logo(v-else :src="$store.getters.currentTenantSquareLogoPath")

  slot(name='header')
</template>

<script>
import { SaveTrees } from "@timesheets/constants-common";
import "./scss";
import { isReservedDomainName } from "@gemma/web-common";

export default {
  name: "LogoHeader",
  props: {
    homeUrl: {
      type: String,
      required: false,
      default: () => (isReservedDomainName(SaveTrees.ReservedDomains) ? SaveTrees.Www.Home : undefined),
    },
  },
};
</script>
